export default __webpack_public_path__ + "static/media/usdt.f8e849c3.svg";